import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'tm-page-not-found-illustration',
    templateUrl: './tm-page-not-found-illustration.component.html',
    styleUrls: ['./tm-page-not-found-illustration.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TmPageNotFoundIllustrationComponent {}
